















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SyncStatus } from '../enums/syncStatus';

@Component
export default class WizardSummary extends Vue {
  @Prop() public data: SyncStatus = SyncStatus.NOT_STARTED;
  public syncStatus: SyncStatus = SyncStatus.NOT_STARTED;

  @Prop() public integration!: string;

  public lang = 'en';

  public async created() {
    this.lang = this.$i18n.locale;
  }

  @Watch('data')
  public updateSyncStatus() {
    this.syncStatus = this.data;
  }

  public goToPortal() {
      this.$router.push('/search-contact');
  }
}
